import { ArtisanContext } from "./ArtisanContext"
import { useEffect, useState, useCallback, useMemo } from "react"
import {
  fetchAllArtisansService,
  fetchFilteredArtisansService,
  fetchFeaturedArtisansService,
  fetchSuggestedArtisansService,
} from "../../global-services/artisan.service"
import { UserContext } from "../user/UserContext"
import { useContext } from "react"

function ArtisanProvider({ children }) {
  const {loggedIn} = useContext(UserContext)
   const [loadingArtisan, setLoadingArtisan] = useState(true)
  const [loadingFeaturedArtisans, setLoadingFeaturedArtisans] = useState(true)
  const [loadingSuggestedArtisans, setLoadingSuggestedArtisans] = useState(true)
  const [errorFeaturedArtisans, setErrorFeaturedArtisans] = useState(null)
  const [artisans, setArtisans] = useState([])
  const [featuredArtisans, setFeaturedArtisans] = useState([])
  const [suggestedArtisans, setSuggestedArtisans] = useState([])
  const [pagination, setPagination] = useState({})
  const [error, setError] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(6)

  const [filters, setFilters] = useState({
    category: "all",
    priceRange: "all",
    sortBy: "rating",
    verifiedOnly: false,
  })

  const hasActiveFilters = useMemo(() => {
  return (
    filters.category !== "all" ||
    filters.priceRange !== "all" ||
    filters.verifiedOnly
  )
}, [filters])

  const fetchArtisans = useCallback(async () => {
    try {
      setLoadingArtisan(true)
      setError(null)

      const data = hasActiveFilters
        ? await fetchFilteredArtisansService({
            page,
            limit,
            filters,
          })
        : await fetchAllArtisansService({
            page,
            limit,
          })

      setArtisans(data.artisanDetails || [])
      
      setPagination(data.pagination || {})
    } catch (err) {
      setError(err.message)
      setArtisans([])
    } finally {
      setLoadingArtisan(false)
    }
  }, [page, limit, filters, refresh, hasActiveFilters])

  const fetchFeaturedArtisans = useCallback(async () => {
    try {
      setLoadingFeaturedArtisans(true)
      const data = await fetchFeaturedArtisansService()
      setFeaturedArtisans(data.artisans || [])
    } catch (err) {
      setErrorFeaturedArtisans(err.message)
      setFeaturedArtisans([])
    } finally {
      setLoadingFeaturedArtisans(false)
    }
  }, [])

  const fetchSuggestedArtisans = useCallback(async () => {
    if(!loggedIn) {
      setLoadingSuggestedArtisans(false)
      return
    }
    try {
      setLoadingSuggestedArtisans(true)
      const data = await fetchSuggestedArtisansService()
      setSuggestedArtisans(data.artisans || [])
    } catch (err) {
      console.error("fetchSuggestedArtisans error:", err)
    } finally {
      setLoadingSuggestedArtisans(false)
    }
  }, [loggedIn])

  

  useEffect(() => {
    fetchArtisans()
  }, [fetchArtisans])

  useEffect(() => {
    fetchFeaturedArtisans()
    fetchSuggestedArtisans()
  }, [fetchFeaturedArtisans, fetchSuggestedArtisans])

  return (
    <ArtisanContext.Provider
      value={{
        loadingArtisan,
        artisans,
        featuredArtisans,
        suggestedArtisans,
        loadingFeaturedArtisans,
        loadingSuggestedArtisans,
        errorFeaturedArtisans,
        error,
        pagination,
        page,
        limit,
        filters,
        setPage,
        setLimit,
        setFilters,
        refresh,
        setRefresh,
      }}
    >
      {children}
    </ArtisanContext.Provider>
  )
}

export default ArtisanProvider
